import { render, staticRenderFns } from "./OrderHolder.vue?vue&type=template&id=2568fbab&"
import script from "./OrderHolder.vue?vue&type=script&lang=js&"
export * from "./OrderHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports